import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Approves an entity.
 * POST api/Onboarding/approve-entity?entityPrimaryId={id}
 * No request body required.
 *
 * @param {number} entityPrimaryId - entityPrimaryId from the entity record
 */
export const approveEntityAction = async (entityPrimaryId) => {
  try {
    const response = await apiClient.post(
      `${ATP_API_URL.APPROVE_ENTITY_NEW}?entityPrimaryId=${entityPrimaryId}`,
    );

    console.log("[Approve] response:", response?.data);

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to approve entity",
        };
      }
      return {
        success: true,
        message: response.data?.message || "Entity approved successfully",
      };
    }

    return { success: false, message: "Failed to approve entity" };
  } catch (error) {
    console.error("[Approve] error:", error);
    return {
      success: false,
      message: error.message || "Failed to approve entity",
    };
  }
};
